var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eligible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-View",
    transform: "translate(-280.000000, -618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(223.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(39.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eligible",
    transform: "translate(18.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#167167",
    strokeWidth: 2,
    cx: 11,
    cy: 11,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5770471,7.24428998 C17.0537414,7.629855 17.1276163,8.32885431 16.7420513,8.80554865 C16.7414203,8.80632886 16.7407881,8.80710822 16.740155,8.80788672 L10.4090001,16.5921592 C10.0302929,17.0577868 9.35368512,17.1388033 8.87669603,16.7833097 C8.75500993,16.7221736 8.6416964,16.6378814 8.54448268,16.5303877 L4.29714636,11.8339138 C3.91359475,11.4098032 3.91672918,10.7715372 4.28482101,10.3518047 L4.37852292,10.2569553 L4.37852292,10.2569553 C4.83803626,9.84369004 5.54531285,9.88018798 5.95984681,10.3385571 L9.46910686,14.218917 L15.0092044,7.40784077 C15.397419,6.9305238 16.0986791,6.85737127 16.5770471,7.24428998 Z",
    id: "Combined-Shape",
    fill: "#167167"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligible);
export default __webpack_public_path__ + "static/media/eligible.27dc7b469517884dbe09c3ffcf510c61.svg";
export { ForwardRef as ReactComponent };